import {
  Divider,
  Heading,
  Paragraph,
  Skeleton,
} from "@digdir/designsystemet-react";

export const BekreftelseSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <Heading data-size="lg" className="mb-4 flex flex-row gap-8">
          <Skeleton variant="circle" width={50} />
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={70} />
        </Paragraph>
      </div>
      <Divider />
      <div>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={25} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={50} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={30} />
        </Paragraph>
        <Paragraph>
          <Skeleton variant="text" width={40} />
        </Paragraph>
      </div>
      <div className="flex flex-col gap-4">
        <Heading data-size="lg">
          <Skeleton variant="text" width={20} />
        </Heading>
        <div>
          <Heading>
            <Skeleton variant="text" width={20} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={300} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={20} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={300} />
          </Paragraph>
        </div>
      </div>
      <Divider />

      <div className="flex flex-col gap-4">
        <Heading data-size="lg">
          <Skeleton variant="text" width={20} />
        </Heading>
        <div>
          <Heading>
            <Skeleton variant="text" width={20} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={300} />
          </Paragraph>
        </div>
        <div>
          <Heading>
            <Skeleton variant="text" width={20} />
          </Heading>
          <Paragraph>
            <Skeleton variant="text" width={300} />
          </Paragraph>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Heading data-size="lg">
          <Skeleton variant="text" width={20} />
        </Heading>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={300} />
        </Paragraph>
        <Heading>
          <Skeleton variant="text" width={20} />
        </Heading>
        <Paragraph>
          <Skeleton variant="text" width={300} />
        </Paragraph>
      </div>
    </div>
  );
};
